﻿import { defineComponent } from 'vue';

import header_menu from "../../../booking_engine/components/header/menu.vue"

import details_content from "./details_content.vue";

export default defineComponent({
    components: {
        header_menu,
        details_content
    }
});